export default {
  default: [
    {
      path: "/account",
      name: "account",
      component: () => import("./views/AccountView.vue")
    },
    {
      path: "/mijn-bedrijfsgegevens",
      name: "business",
      component: () => import("./views/BusinessView.vue")
    },
    {
      path: "/mijn-adviseur",
      name: "partner",
      component: () => import("./views/PartnerView.vue")
    },
    {
      path: "/documenten",
      name: "documents",
      component: () => import("./views/DocumentsView.vue")
    }
  ]
};
